import React, { useEffect, useState } from 'react';
import ConfirmationDialog from '../ConfirmationDialog.js';
import { useDispatch, useSelector } from 'react-redux';
import { Country, State, City } from 'country-state-city';
import Select from 'react-select';

const AddBuyers = ({ setShowForm }) => {
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem('user'));
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [viewDetails, setViewDetails] = useState(false);

  const initialBuyerData = {
    firstName: '',
    lastName: '',
    gender: '',
    emailId: '',
    phoneNumber: '',
    homeName: '',
    doorNo: '',
    street: '',
    townOrCity: '',
    state: '',
    country: '',
    pincode: '',
    landMark: '',
  };
  const [buyerData, setBuyerData] = useState(initialBuyerData);
  const { selectedBuyer } = useSelector((state) => state.buyerRedux);

  const countryOptions = Country.getAllCountries().map((country) => ({
    label: country.name,
    value: country.isoCode,
  }));

  const stateOptions = selectedCountry
    ? State.getStatesOfCountry(selectedCountry.value).map((state) => ({
        label: state.name,
        value: state.isoCode,
      }))
    : [];

  const cityOptions =
    selectedCountry && selectedState
      ? City.getCitiesOfState(selectedCountry.value, selectedState.value).map(
          (city) => ({
            label: city.name,
            value: city.name,
          })
        )
      : [];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBuyerData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleClose = () => {
    resetForm();
    setShowForm(false);
    setViewDetails(false);
    localStorage.setItem('vM', 'false');
  };

  useEffect(() => {
    const isViewMode = localStorage.getItem('vM');
    if (isViewMode === 'true' && selectedBuyer) {
      setViewDetails(true);
      setBuyerData({
        firstName: selectedBuyer.firstName || '',
        lastName: selectedBuyer.lastName || '',
        gender: selectedBuyer.gender || '',
        emailId: selectedBuyer.emailId || '',
        phoneNumber: selectedBuyer.phoneNumber || '',
        homeName: selectedBuyer.address?.[0]?.homeName || '',
        doorNo: selectedBuyer.doorNo?.[0]?.doorNo || '',
        street: selectedBuyer.address?.[0]?.street || '',
        country: selectedBuyer.address?.[0]?.country || '',
        state: selectedBuyer.address?.[0]?.state || '',
        city: selectedBuyer.address?.[0]?.townOrCity || '',
        pincode: selectedBuyer.address?.[0]?.pincode || '',
        landMark: selectedBuyer.address?.[0]?.landMark || '',
      });
      setViewDetails(true);
    }
  }, [dispatch, setShowForm, selectedBuyer, viewDetails]);

  const handleSelectChange = (e) => {
    setBuyerData({
      ...buyerData,
      gender: e.target.value,
    });
  };

  const resetForm = () => {
    setBuyerData(initialBuyerData);
  };
  return (
    <>
      <div className='m-3'>
        <h5 className='text-center'>Seller Details</h5>
        <div style={{ padding: '25px' }}>
          <form>
            <div className='row d-flex justify-content-center'>
              <div className='col-6'>
                <label htmlFor='firstName'>
                  First Name <span className='requiredAsterisk'>*</span>
                </label>
                <input
                  type='text'
                  value={buyerData.firstName}
                  onChange={handleChange}
                  id='firstName'
                  name='firstName'
                  className='form-control mb-3'
                  style={{ border: '1px solid #cccccc' }}
                  required
                  readOnly={viewDetails}
                />
              </div>
              <div className='col-6'>
                <label htmlFor='lastName'>
                  Last Name<span className='requiredAsterisk'>*</span>
                </label>
                <input
                  type='text'
                  value={buyerData.lastName}
                  onChange={handleChange}
                  id='lastName'
                  name='lastName'
                  className='form-control mb-3'
                  style={{ border: '1px solid #cccccc' }}
                  required
                  readOnly={viewDetails}
                />
              </div>
              <div className='col-4'>
                <label htmlFor='gender'>
                  Gender <span className='requiredAsterisk'>*</span>
                </label>
                <select
                  id='gender'
                  className='form-control mb-3'
                  style={{ border: '1px solid #cccccc' }}
                  value={buyerData.gender}
                  onChange={handleSelectChange}
                  disabled={viewDetails}
                >
                  <option value='' disabled>
                    Select Gender
                  </option>
                  <option value='Male'>Male</option>
                  <option value='Female'>Female</option>
                </select>
              </div>
              <div className='col-4'>
                <label htmlFor='emailId'>
                  Email Id<span className='requiredAsterisk'>*</span>
                </label>
                <input
                  type='email'
                  value={buyerData.emailId}
                  onChange={handleChange}
                  id='emailId'
                  name='emailId'
                  className='form-control mb-3'
                  style={{ border: '1px solid #cccccc' }}
                  required
                  readOnly={viewDetails}
                />
              </div>
              <div className='col-4'>
                <label htmlFor='phoneNumber'>
                  Phone Number<span className='requiredAsterisk'>*</span>
                </label>
                <input
                  type='tel'
                  id='phoneNumber'
                  className='form-control mb-3'
                  name='phoneNumber'
                  style={{ border: '1px solid #cccccc' }}
                  value={buyerData.phoneNumber}
                  onChange={handleChange}
                  // maxLength={4}
                  pattern='[0-9]*'
                  readOnly={viewDetails}
                />
              </div>
            </div>
            <div className='row mt-3'>
              <div className='col-12'>
                <h5 style={{ color: 'var(--primary-color)' }}>
                  Address
                  <span>
                    <p className='text-muted'>
                      The buyer can have one or more addresses, The address
                      below was the most recently used.{' '}
                    </p>
                  </span>
                </h5>
              </div>
              <div className='col-6'>
                <label htmlFor='homeName'>
                  Home Name<span className='requiredAsterisk'>*</span>
                </label>
                <input
                  type='email'
                  value={buyerData.homeName}
                  onChange={handleChange}
                  id='homeName'
                  name='homeName'
                  className='form-control mb-3'
                  style={{ border: '1px solid #cccccc' }}
                  required
                  readOnly={viewDetails}
                />
              </div>
              <div className='col-6'>
                <label htmlFor='doNo'>
                  Door No<span className='requiredAsterisk'>*</span>
                </label>
                <input
                  type='email'
                  value={buyerData.doNo}
                  onChange={handleChange}
                  id='doNo'
                  name='doNo'
                  className='form-control mb-3'
                  style={{ border: '1px solid #cccccc' }}
                  required
                  readOnly={viewDetails}
                />
              </div>
              <div className='col-6'>
                <label htmlFor='street'>
                  Street Name<span className='requiredAsterisk'>*</span>
                </label>
                <input
                  type='email'
                  value={buyerData.street}
                  onChange={handleChange}
                  id='street'
                  name='street'
                  className='form-control mb-3'
                  style={{ border: '1px solid #cccccc' }}
                  required
                  readOnly={viewDetails}
                />
              </div>
              <div className='col-6'>
                <div className='form-group mb-3'>
                  <label>
                    Country<span className='requiredAsterisk'>*</span>
                  </label>
                  {!viewDetails ? (
                    <Select
                      options={countryOptions}
                      value={selectedCountry}
                      onChange={(option) => {
                        setSelectedCountry(option);
                        setSelectedState(null);
                        setSelectedCity(null);
                        setBuyerData((prevData) => ({
                          ...prevData,
                          country: option.label,
                        }));
                      }}
                      placeholder='Select country'
                    />
                  ) : (
                    <input
                      type='text'
                      value={buyerData.country}
                      className='form-control mb-3'
                      style={{ border: '1px solid #cccccc' }}
                      readOnly
                    />
                  )}
                </div>
              </div>
              <div className='col-6'>
                <div className='form-group mb-3'>
                  <label>
                    State<span className='requiredAsterisk'>*</span>
                  </label>
                  {!viewDetails ? (
                    <Select
                      options={stateOptions}
                      value={selectedState}
                      onChange={(option) => {
                        setSelectedState(option);
                        setSelectedCity(null);
                        setBuyerData((prevData) => ({
                          ...prevData,
                          state: option.label,
                        }));
                      }}
                      placeholder='Select state'
                      isDisabled={!selectedCountry}
                    />
                  ) : (
                    <input
                      type='text'
                      value={buyerData.state}
                      className='form-control mb-3'
                      style={{ border: '1px solid #cccccc' }}
                      readOnly
                    />
                  )}
                </div>
              </div>

              <div className='col-6'>
                <div className='form-group mb-3'>
                  <label>
                    City<span className='requiredAsterisk'>*</span>
                  </label>
                  {!viewDetails ? (
                    <Select
                      options={cityOptions}
                      value={selectedCity}
                      onChange={(option) => {
                        setSelectedCity(option);
                        setBuyerData((prevData) => ({
                          ...prevData,
                          townOrCity: option.label,
                        }));
                      }}
                      placeholder='Select city'
                      isDisabled={!selectedState}
                    />
                  ) : (
                    <input
                      type='text'
                      value={buyerData.city}
                      className='form-control mb-3'
                      style={{ border: '1px solid #cccccc' }}
                      readOnly
                    />
                  )}
                </div>
              </div>
              <div className='col-6'>
                <label htmlFor='pincode'>
                  Pincode<span className='requiredAsterisk'>*</span>
                </label>
                <input
                  type='email'
                  value={buyerData.pincode}
                  onChange={handleChange}
                  id='pincode'
                  name='pincode'
                  className='form-control mb-3'
                  style={{ border: '1px solid #cccccc' }}
                  required
                  readOnly={viewDetails}
                />
              </div>
              <div className='col-6'>
                <label htmlFor='landMark'>
                  Landmark<span className='requiredAsterisk'>*</span>
                </label>
                <input
                  type='email'
                  value={buyerData.landMark}
                  onChange={handleChange}
                  id='landMark'
                  name='landMark'
                  className='form-control mb-3'
                  style={{ border: '1px solid #cccccc' }}
                  required
                  readOnly={viewDetails}
                />
              </div>
            </div>

            <div className='row d-flex justify-content-center'>
              <div className='col-6 text-center'>
                <button
                  className='btn w-100'
                  style={{
                    background: '#C0000B',
                    color: '#fff',
                    padding: '10px',
                  }}
                  onClick={handleClose}
                >
                  Close
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddBuyers;
